export default defineNuxtPlugin(() => {
  const sound = useSound()
  return {
    provide: {
      sound,
    },
  }
})
